/**
 * ProgressBar — simple themed progress bar used by the loading screen.
 */
import { Theme } from './Theme.js';

export class ProgressBar {
  /**
   * @param {object} opts
   * @param {Phaser.Scene} opts.scene
   * @param {number} opts.x
   * @param {number} opts.y
   * @param {number} [opts.width=300]
   * @param {number} [opts.height=14]
   */
  constructor(opts) {
    this.scene = opts.scene;
    this.width = opts.width || 300;
    this.height = opts.height || 14;
    this._value = 0;

    this.bg = this.scene.add.graphics();
    this.fill = this.scene.add.graphics();
    this.x = opts.x;
    this.y = opts.y;
    this._draw();
  }

  setValue(v) {
    if (v < 0) v = 0;
    if (v > 1) v = 1;
    this._value = v;
    this._draw();
  }

  _draw() {
    const x = this.x - this.width / 2;
    const y = this.y - this.height / 2;
    this.bg.clear();
    this.bg.fillStyle(Theme.colors.surfaceAlt, 1);
    this.bg.fillRoundedRect(x, y, this.width, this.height, this.height / 2);
    this.fill.clear();
    this.fill.fillStyle(Theme.colors.primary, 1);
    if (this._value > 0) {
      this.fill.fillRoundedRect(x, y, this.width * this._value, this.height, this.height / 2);
    }
  }

  destroy() {
    this.bg.destroy();
    this.fill.destroy();
  }
}
